import { Controller } from "@hotwired/stimulus"

// Row-level archive button. Fades the row out and removes it without
// a page reload. Confirm dialog inline so the user can't fat-finger
// the icon on a half-second hover.
export default class extends Controller {
  static values = { url: String, taskId: Number }

  async archive(event) {
    event.stopPropagation()
    if (!window.confirm("Archive this task? It will move to the Archived view.")) return

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    try {
      const res = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Accept": "application/json",
          "X-CSRF-Token": token
        }
      })
      if (!res.ok) {
        alert("Could not archive task.")
        return
      }
      this._removeRow()
    } catch (e) {
      alert("Could not archive task.")
    }
  }

  _removeRow() {
    const row = this.element.closest(".task-row")
    if (!row) return
    // Multi-assignee tasks have a sibling expansion row to clean up too.
    const next = row.nextElementSibling
    row.style.transition = "opacity 200ms"
    row.style.opacity = "0"
    setTimeout(() => {
      if (next && next.classList.contains("status-per-assignee")) next.remove()
      row.remove()
    }, 200)
  }
}
